export const translations = {
    ro: {

      common: {
        ovens: "cuptoare",
        cookers: "Aragazuri",
        hobs: "plite",
        oven: "cuptor",
        cooker: "aragazuri",
        hob: "plită",
        nav_step1: "<span>PASUL 1.</span> Introduceţi datele",
        nav_step2: "<span>PASUL 2.</span> Înregistraţi produsele dumneavoastră",
        nav_step3: "<span>PASUL 3.</span> Sumar",
        btn_next_step: "Pasul următor",
        edit: "Editați",
        delete: "șterge"
      },

      kv: {
        t1: "Beneficiaţi<br />de garanţie",
        t2: "în trei paşi simpli!",
        button: "Înregistraţi produsele dumneavoastră"
      },

      header: {
        product_registration: "Înregistrarea produsului",
        promotion_rules: "Regulile promoţiei",
        eligible_products: "Produse eligibile",
        terms_and_conditions: "Termeni şi condiţii",
        contact: "Contact"
      },

      footer: {
        copy: "5 ani garanţie © Amica. Toate drepturile rezervate 2020."
      },

      product_registration: {
        heading: "Înregistraţi produsele dumneavoastră",
        online_heading: "Înregistrare online",
        online_content: "<p>Înregistraţi produsele dumneavoastră utilizând formularul de înregistrare online.<br /><br />* Înregistrarea poate fi făcută şi prin e-mail la adresa: <a href='mailto:5yearwarranty@hansa-home.ro'>5yearwarranty@hansa-home.ro</a></p>",
        online_button: "Formular de înregistrare online",
        offline_heading: "Înregistrare prin poştă",
        offline_content: "<p>Înregistraţi produsele dumneavoastră utilizând formularul de înregistrare descărcabil ca fişier PDF de pe site-ul nostru web. <br /><br />Tipăriţi-l, completaţi-l şi trimiteţi-l la următoarea adresă prin poştă recomandată, incluzând imagini scanate/fotografii clare ale dovezii de achiziţie a produselor dumneavoastră: <br /><br />Lorem ipsum dolor sit, ul. Uliczna 5/2, 61-532 Poznań, Polonia, cu următoarea menţiune:  „5 ani garanţie Hansa”. Descărcaţi şi completaţi chestionarul:</p>",
        phone_heading: "Înregistrare prin TELEFON",
        phone_number: "+48 345 235 652"
      },

      promotion_rules: {

      },

      eligible_products: {
        heading: "Produse eligibile",
        vat_info: "*Preţul de vânzare cu amănuntul indicat în factura/chitanţa cu TVA, care a fost plătit efectiv de către cumpărător - după aplicarea oricăror reduceri acordate de punctul de vânzare."
      },

      contact: {
        heading: "Contact",
        content: "<p>Ne puteţi contacta prin e-mail la adresa: <a href='mailto:5yearwarranty@hansa-home.ro'>5yearwarranty@hansa-home.ro</a></p>",
        complaint: "Reclamatie",
        complaintContent: "<p><b>Reclamaţiile pot fi depuse prin</b> -mail la adresa: <a href='mailto:5yearwarranty@hansa-home.ro'>5yearwarranty@hansa-home.ro</a></p>",
        complaintContent2: "<p><i>*Condiția de participare la promoție este completarea corectă a formularului de cerere și cunoașterea termenilor Promoției. Termenii şi condiţiile promoţiei „Garanţie extinsă” și Procedura de reclamare sunt disponibile pe site-ul web: <a href='/5yearwarranty/files/terms.pdf'>www.hansa-home.ro/5yearwarranty/files/terms.pdf</a></i></p>"
      },

      terms_conditions: {
        heading: "Termenii şi condiţiile promoţiei",
        date_info: "Promoţia începe la <strong>01/01/2026</strong> şi se încheie la <strong>31/12/2026</strong>",
        step1: "<strong>1. Achiziţionaţi</strong> un aparat Hansa (un cuptor, aragaz independent sau plită) de la orice magazin.",
        step2: "<strong>2. Completaţi</strong> formularul de înregistrare.",
        step3: "<strong>3. Obţineţi</strong> un certificat care confirmă garanţia de 5 ani",
      },

      step1: {
        heading: "Introduceţi datele",
        first_name: "Prenume",
        last_name: "Nume",
        street: "Stradă",
        house_number: "Număr",
        flat_number: "Număr apartament",
        city: "Localitate",
        zip_code: "Cod poştal",
        administrative_region_2: "Judet",
        phone_number: "Număr de telefon",
        email: "Adresă de e-mail",
        agreements_main_heading: "Consimţământ necesar pentru a participa la „Promoţia garanţie de 5 ani” („Promoţia”) – vă rugăm să marcaţi declaraţiile cu care sunteţi de acord.",
        agreements_danger: "*Neconfirmarea citirii şi acceptării termenilor şi condiţiilor Promoţiei şi neacordarea consimţământului pentru prelucrarea datelor cu caracter personal în scopurile",
        agreements_marketing_heading: "Consimţământ de marketing – Vă rugăm să marcaţi declaraţiile cu care sunteţi de acord.",

        main_agreement: "Confirm faptul că am citit <a target='_blank' href='/5yearwarranty/files/terms.pdf'>Termenii și Condițiile</a> Promoției și că le accept.",
        terms_agreement: "Declar că sunt de acord cu prelucrarea datelor mele cu caracter personal incluse în cererea de înregistrare și documentele însoțitoare prelucrate de Amica Handel i Marketing Sp. z o.o. cu sediul social în Poznan (60-320), Strada Bulgarska, nr. 17, Polonia, în scopul participării la Promoție și a primirii premiilor. Consimțământul este voluntar, dar necesar pentru participarea la Promoție.",
        main_agreement_3: 'Confirm faptul că am citit <a target="_blank" href="files/personal_data_processing.pdf">regulamentul de prelucrare a datelor cu caracter personal.</a>',
        electronic_agreement: 'Sunt de acord cu prelucrarea datelor mele cu caracter personal de către Amica Handel i Marketing Sp. z o.o., cu sediul social în Poznan (60-320), Strada Bulgarska, nr. 17, Polonia, în scopuri de marketing direct (şi anume: sub formă de mesaje text, e-mail, prin telefon). Prin prezenta accept faptul că Amica Handel i Marketing sp. z o. o. îmi va trimite informații de marketing, în special constând în informații privind produsele Amica, prin mijloace de comunicare electronice, telefon și echipamente terminale de comunicații, și sisteme de apelare automată. Prin prezenta, confirm faptul că am fost informat(ă) în legătură cu faptul că acest consimțământ este voluntar – nu este necesar pentru a participa la Promoție – și că am dreptul de a-mi retrage consimțământul în orice moment.',
        marketing_agreement: "Sunt de acord cu prelucrarea datelor mele cu caracter personal de către Amica Handel i Marketing Sp. z o.o., cu sediul social în Poznan (60-320), Strada Bulgarska, nr. 17, Polonia, pentru a-mi trimite informații de marketing, în special constând în informaţii privind produsele Amica.",
        agreement_new: "",
        agreements_info_heading: "",
        agreements_info: ''
      },

      step2: {
        heading: "Selectaţi produsele",
        select_product_list: "Selectaţi produsul din listă",
        select_product: "Selectaţi produsul",
        btn_register: "Înregistraţi",
        select_product_prefix: "Selectaţi",
        btn_select_product: "Selectaţi",
        form_heading: "Produs selectat",
        serial_number: "Număr de serie",
        purchase_date: "Data achiziţionării",
        shop_type: "Locul achiziţionării",
        shop_www: "Introduceţi adresa magazinului online",
        shop_name: "Denumire magazin",
        shop_address: "Adresă",
        shop_city: "Oraş",
        shop_zip_code: "Cod poştal",
        doc_purchase: "Dovada scanată a achiziţiei (factura sau bon fiscal)",
        doc_warranty: "Coperta scanată a certificatului de garanție emis de catre producator",
        list_element_online: "Online",
        list_element_offline: "Staţionar",
        notify_product_added: "Produs înregistrat",
        notify_product_removed: "Produs eliminat",
        prod_name_label: "Introduceţi denumirea produsului",
        prod_name: "Denumire produs",
        or: 'sau'
      },

      step3: {
        heading: "Vă mulţumim pentru participarea la promoţia noastră!",
        info: "Am trimis un mesaj de e-mail de confirmare la adresa de e-mail pe care aţi specificat-o. Vă rugăm să verificaţi şi folderul SPAM dacă este necesar",
        go_mainpage: "Accesaţi pagina principală"
      }

    }
  }

  // validation messages
  // vvlocale.messages.required = 'Field is required'
  // vvlocale.messages.regex = 'Field format is invalid' // ie. post code must be xx-xxx
  // vvlocale.messages.min = 'Serial number must be at least 14 digits'
